import { render, staticRenderFns } from "./LogoSizeChoice.vue?vue&type=template&id=11aa3322&"
import script from "./LogoSizeChoice.vue?vue&type=script&lang=js&"
export * from "./LogoSizeChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default})
